export default {
  form: {
    type:'',  //举报类型
    exploreShopNo: '', //举报人探店号 
    reportExploreShopNo: '', //被举报探店号
    videoId: '', //视频id
    reportClass: '', //举报类目
    // reportContent: '', //举报内容
    // reportDate: '', //举报时间  "yyyy-MM-dd HH:mm:ss"
    // status: '', //状态
    // handleTime: '', //处理时间
    // handler: '', //处理人
    // image: '', //图片 必要 多个逗号分开
    // remarks: '', //备注
  }
}